<script>
import axios from 'axios';
import utilsService from '@/api/utilsService';

const apiUrl = `${process.env.VUE_APP_API_URL}/api/peticionproductos`;

function authHeaders() {
  return {
    'Authorization': `Bearer ${utilsService.getToken()}`,
    'Content-Type': 'application/json',
  };
}

// El idioma viaja a la API para que resuelva el nombre del tipo de solicitud
// desde dbo.Diccionarios (Nombre o NombreIngles).
function idioma() {
  return localStorage.getItem('language') || 'es';
}

// GET /api/peticionproductos
async function getAll() {
  const response = await axios.get(`${apiUrl}?lang=${idioma()}`, { headers: authHeaders() });
  return response.data;
}

// GET /api/peticionproductos/mis-solicitudes  — solicitudes del usuario autenticado
async function getMisSolicitudes() {
  const response = await axios.get(`${apiUrl}/mis-solicitudes?lang=${idioma()}`, { headers: authHeaders() });
  return response.data;
}

// POST /api/peticionproductos  — crea una solicitud.
// Es el mismo endpoint que usa el formulario publico del ecommerce; alli el
// CAPTCHA lo resuelve el proxy de Next, aca basta con la sesion del usuario.
async function create(data) {
  const response = await axios.post(apiUrl, data, { headers: authHeaders() });
  return response.data;
}

// GET /api/peticionproductos/{id}
async function getById(id) {
  const response = await axios.get(`${apiUrl}/${id}?lang=${idioma()}`, { headers: authHeaders() });
  return response.data;
}

// PUT /api/peticionproductos/{id}  — solo Estado y ObservacionInterna
async function update(id, data) {
  const response = await axios.put(`${apiUrl}/${id}`, data, { headers: authHeaders() });
  return response.data;
}

// DELETE /api/peticionproductos/{id}  — baja logica (Activo = 0), no borra la fila
async function remove(id) {
  const response = await axios.delete(`${apiUrl}/${id}`, { headers: authHeaders() });
  return response.data;
}

// GET /api/peticionproductos/registro/{codigo}  — sin auth, datos para el formulario de registro
async function getRegistroData(codigo) {
  const response = await axios.get(`${apiUrl}/registro/${codigo}`);
  return response.data;
}

// POST /api/peticionproductos/registro/{codigo}/crear-cuenta  — sin auth, crea cuenta comprador
async function crearCuentaComprador(codigo, data) {
  const response = await axios.post(`${apiUrl}/registro/${codigo}/crear-cuenta`, data);
  return response.data;
}

export default {
  getAll,
  getMisSolicitudes,
  create,
  getById,
  update,
  remove,
  getRegistroData,
  crearCuentaComprador,
};
</script>
